__turbopack_context__.v({
  "fade-in-unwkqss": "emptyList-module-scss-module__Ejz-za__fade-in-unwkqss",
  "text": "emptyList-module-scss-module__Ejz-za__text",
  "title": "emptyList-module-scss-module__Ejz-za__title",
  "title-icon": "emptyList-module-scss-module__Ejz-za__title-icon",
  "title-icon-background": "emptyList-module-scss-module__Ejz-za__title-icon-background",
  "wrapper": "emptyList-module-scss-module__Ejz-za__wrapper",
});
